import {type ErrorCode, ErrorCodes} from '@nursio-link/common';
import {ClientError} from 'graphql-request';

interface ParsedError {
  errorCode: ErrorCode;
  statusCode: number;
}

const isValidErrorCode = (code: unknown): code is ErrorCode => {
  const validCodes = Object.values(ErrorCodes);

  return typeof code === 'string' && validCodes.includes(code as ErrorCode);
};

const parseErrorCode = (
  errorMessage: string | undefined,
  statusCode: number
): ParsedError => {
  if (isValidErrorCode(errorMessage)) {
    return {errorCode: errorMessage, statusCode};
  }
  return {errorCode: 'INTERNAL_SERVER_ERROR', statusCode: 500};
};

export const parseError = (error: unknown): ParsedError => {
  if (error instanceof ClientError) {
    const errorCode = error.response.errors?.[0]?.message;
    return parseErrorCode(errorCode, error.response.status);
  }

  if (error instanceof Error) {
    return parseErrorCode(error?.message, 500);
  }

  if (typeof error === 'string') {
    return parseErrorCode(error, 500);
  }
  return {errorCode: 'INTERNAL_SERVER_ERROR', statusCode: 500};
};
